import clsx from 'clsx';
import { FC } from 'react';

const listContainerStyles = 'list-outside pl-5 mt-0.5 mb-2';

export const CustomUlComponent: FC = ({ children }) => (
  <ul className={clsx('list-disc', listContainerStyles)}>{children}</ul>
);

export const CustomOlComponent: FC = ({ children }) => (
  <ol
    className={clsx(
      'list-decimal [&_ol]:list-[lower-alpha] [&_ol_ol]:list-[lower-roman] [&_li]:pl-1',
      listContainerStyles,
    )}
  >
    {children}
  </ol>
);
